import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './styles.css'
import 'material-icons/iconfont/material-icons.css'

const CustomToast = ({ type, message, error }) => {

  const [showDetails, setShowDetails] = useState(type === '')

  const toggleDetails = () => {
    setShowDetails(!showDetails)
  }

  const stripeClass = type === 'error' ? 'stripe stripe-error' : 'stripe stripe-success'
  const errorClass = `error ${showDetails ? 'visible' : 'hidden'}`

  return (
    <div className="container">
      <div className={stripeClass} />
      <span className="message">{message}</span>
      {type === 'error' && error !== null && (
        <>
          <span className={errorClass}>
            {`Detalhes: ${error}`}
          </span>
          <div className="details-container">
            <i className="material-icons" style={{ verticalAlign: 'middle', fontSize: 'inherit' }}>info</i>
            <span className="details-btn" onClick={toggleDetails}>
              {showDetails ? 'Ocultar detalhes' : 'Ver detalhes'}
            </span>
          </div>
        </>
      )}
    </div>
  )

}

CustomToast.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  error: PropTypes.string
}

CustomToast.defaultProps = {
  error: null
}

export default CustomToast
